export default __webpack_public_path__ + "static/media/2412306.7498ee84.webp";